import { getTintVTOService } from "services/tintvto"
import { clearBillingState } from "store/billing/billingSlice"
import { clearProductSlice } from "store/product/productSlice"
import { IntegrationType } from "types"
import { clearTiendanubeToken, getTiendanubeToken } from "utils/authSessionStorage"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { type RootState } from "../store"
import { clearUserInfo, selectUser } from "./userSlice"

export const initializeUser = createAsyncThunk<void, void, { state: RootState }>(
  "user/initializeUser",
  async (_, { dispatch, getState }) => {
    const state = getState()
    const user = selectUser(state)
    const service = getTintVTOService()

    if (user && user.userInfo.username) {
      if (user.userInfo.integrationType === IntegrationType.TIENDANUBE) {
        const token = getTiendanubeToken()

        if (!token) {
          clearTiendanubeToken()
          dispatch(clearBillingState())
          dispatch(clearUserInfo())
          dispatch(clearProductSlice())
          service.changeAwsTokenAndUserType(null, IntegrationType.COMMON)
          return
        }

        service.changeAwsTokenAndUserType(token, IntegrationType.TIENDANUBE)
        return
      }

      service.changeAwsTokenAndUserType(null, user.userInfo.integrationType)
      return
    }

    service.changeAwsTokenAndUserType(null, IntegrationType.COMMON)
  }
)
